<ion-header>
  <ion-toolbar>
    <div class="title-content">
      <ion-row>
        <ion-col size="1"></ion-col>
        <ion-col size="10">
          <ion-title>Manage Delivery </ion-title>
        </ion-col>
        <ion-col size="1">
          <ion-icon
            name="close"
            size="large"
            class="close-icon"
            (click)="onClose()"
          ></ion-icon>
        </ion-col>
      </ion-row>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <div id="map-container-{{penmate.id}}" class="map-container" [pmContactMap]="penmate">
      <div class="map-cover"></div>
      <div class="map"></div>
    </div>
    
    <div class="content-container">
      <div
        class="status-header"
        [ngClass]="{
          'pm-subtitle-left': !isDelivered()
        }"
      >
         <p class="title">
            <span>Your {{ currentMessage?.messageType || 'message' }}</span
            ><span class="status processing" *ngIf="isProcessing()">is processing for delivery 📤</span
            ><span class="status mailed" *ngIf="!isProcessing() && !isDelivered()">has been mailed 📬</span
            ><span class="status delivered" *ngIf="isDelivered()">has been delivered 🙌</span>

            
        </p>
         <p class="subtitle"> 
           <span *ngIf="isProcessing()">
             Your message has been sent and is being processed for delivery. All messages require facility review. You will be notified when delivery is completed.
           </span>

           <ng-container *ngIf="!isProcessing()">
             <ng-container *ngIf="currentMessage?.meta?.emessageShipment; else normalPhysicalMail">
              <span *ngIf="!isDelivered()">
                Your recipient’s facility requires physical mail (per facility policy). Your message is in transit via USPS First-Class. We’ll notify you when delivery is complete.
              </span>
              <span *ngIf="isDelivered()">
                Your recipient’s facility requires physical mail (per facility policy). Your message was delivered via USPS First-Class.
              </span>
             </ng-container>

             <ng-template #normalPhysicalMail>
               <span *ngIf="!isDelivered()">Your message is in transit via USPS First-Class. We’ll notify you when delivery is complete.</span>
               <span *ngIf="isDelivered()">Your message has been delivered to the facility mailroom.</span>
             </ng-template>
           </ng-container>

        </p>
      </div>
      <p class="section-header"> Manage My Delivery</p>
      <div class="delivery-menu" *ngIf="currentMessage?.status">
        <div class="recipient-info" (click)="onShowEditAddress()">
          <ion-row>
            <ion-col size="2">
              <div class="menu-icon">
                <p class="to-from">TO:</p>
              </div>
            </ion-col>
            <ion-col size="10">
              <p class="name">{{currentMessage?.toAddress?.first_name}} {{currentMessage?.toAddress?.last_name}} <span  class="idNumber" *ngIf="currentMessage?.toAddress?.idNumber"> - {{currentMessage.toAddress.idNumber}} </span></p>
              <div class="address-edit">
                <div class="text">
                  <p class="location">{{currentMessage?.toAddress?.facility}}</p>
                </div>
                <div class="edit">
                  <div class="edit-action" *ngIf="isProcessing()">
                    Edit
                    <ion-icon
                      name="md-create"
                    ></ion-icon>
                  </div>
                </div>
              </div>
            </ion-col>

          </ion-row>
        </div>
        <div class="recipient-info"  (click)="onShowEditAddress()">
          <ion-row>
            <ion-col size="2">
              <div class="menu-icon">
                <p class="to-from">FROM:</p>
              </div>
            </ion-col>
            <ion-col size="10">
              <p class="name">{{currentMessage.fromAddress?.name}}</p>
              <div class="address-edit">
                <div class="text">
                  <p class="location email" *ngIf="currentMessage.fromAddress?.address_email">{{currentMessage.fromAddress?.address_email}}</p>
                  <p class="location">{{currentMessage.fromAddress?.address_line1}}</p>
                </div>
                <div class="edit">
                  <div class="edit-action" *ngIf="isProcessing()">
                    Edit
                    <ion-icon
                      name="md-create"
                    ></ion-icon>
                  </div>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </div>
        <div class="menu-actions">

          <ion-row *ngIf="canShowMenuAction('tracking')" (click)="onShowTrackingModal()">
            <ion-col size="2">
              <div class="menu-icon">
                <ion-icon
                  name="ios-mail-unread"
                  size="large"
              ></ion-icon>
              </div>
            </ion-col>
            <ion-col size="10">
              <div class="menu-action"> 
                <p class="title">Track my message</p>
                <p class="subtitle"> Track your delivery</p>
              </div>
            </ion-col>
          </ion-row>
          <ion-row  (click)="onShowHelpWidget('delivery-questions')">
            <ion-col size="2">
              <div class="menu-icon delivery-questions">
                <ion-icon
                  name="ios-help-circle"
                  size="large"
              ></ion-icon>
              </div>
            </ion-col>
            <ion-col size="10">
              <div class="menu-action"> 
                <p class="title">
                    <span>Delivery Questions / Help </span>
                  </p>
                <p class="subtitle"> 
                  <span>Get help with delivery questions</span>
                </p>
              </div>
            </ion-col>
          </ion-row>
          <ion-row  *ngIf="canShowMenuAction('resend')" (click)="onResend()">
            <ion-col size="2">
              <div class="menu-icon">
                <ion-icon
                  name="ios-refresh"
                  size="large"
              ></ion-icon>
              </div>
            </ion-col>
            <ion-col size="10">
              <div class="menu-action"> 
                <p class="title">Resend my {{currentMessage.messageType}}</p>
                <p class="subtitle"> Resend your message & photos</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
  </ion-list>
</ion-content>
